import dayjs from "dayjs";
import { DriverQueryYesNo } from "@farmact/model/src/model/Order";
import * as Item from "../../../../FaItem";
import { IonToggle } from "@ionic/react";

interface IYesNoInputItemProps {
    driverQuery: DriverQueryYesNo;
    onChange: (updateData: Partial<DriverQueryYesNo>) => void;
}

export const YesNoInputItem = (props: IYesNoInputItemProps) => {
    const updateValue = (updatedValue: boolean | null) => {
        props.onChange({
            value: {
                ...props.driverQuery.value,
                timestamp: dayjs().toISOString(),
                checked: updatedValue,
            },
        });
    };

    return (
        <Item.Root>
            <Item.Label>Ja / Nein</Item.Label>
            <Item.Content>
                <IonToggle
                    checked={!!props.driverQuery.value.checked}
                    onIonChange={event => {
                        updateValue(event.detail.checked);
                    }}
                />
            </Item.Content>
        </Item.Root>
    );
};
